<template>
  <v-container fluid style="width: 100%; padding: 0">
    <Header />

    <article class="text-center mobile-center fontscolor">
      <section class="fw-section">
        <div style="background-color: #edf4fe">
          <div class="container fullwidthsec">
            <div class="row" style="padding-top: 50px">
              <div class="page-title title-size-normal text-dark">
                <center>
                  <div class="bluebgtitle">
                    Get the best Maposcope experience
                  </div>
                  <br />
                  Every new account unlocks full access to all Maposcope
                  features, letting you explore and see if we’re the right fit
                  for your needs.
                </center>
              </div>
            </div>
            <center>
              <div class="container fullwidthsec table-responsive">
                <table
                  class="table table-borderless"
                  style="background-color: #ffffff; border-color: #ffffff"
                >
                  <thead>
                    <tr>
                      <th scope="col" style="padding-left: 30px">Free</th>
                      <th scope="col" style="padding-left: 30px">
                        Professional
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <i
                          class="material-icons check text-default"
                          style="
                            font-size: 16px;
                            padding: 0 10px 6px;
                            color: #29a803;
                          "
                        ></i
                        ><strong>0$</strong>
                      </td>
                      <td>
                        <i
                          class="material-icons check text-default"
                          style="
                            font-size: 16px;
                            padding: 0 10px 6px;
                            color: #29a803;
                          "
                        ></i
                        ><strong>10$/driver per month</strong>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <i
                          class="material-icons check text-default"
                          style="
                            font-size: 16px;
                            padding: 0 10px 6px;
                            color: #29a803;
                          "
                        ></i
                        >Maximum of 10 locations on the route
                      </td>
                      <td>
                        <i
                          class="material-icons check text-default"
                          style="
                            font-size: 16px;
                            padding: 0 10px 6px;
                            color: #29a803;
                          "
                        ></i
                        >Maximum of 500 locations on the route
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <i
                          class="material-icons check text-default"
                          style="
                            font-size: 16px;
                            padding: 0 10px 6px;
                            color: #29a803;
                          "
                        ></i
                        >Create and optimize routes
                      </td>
                      <td>
                        <i
                          class="material-icons check text-default"
                          style="
                            font-size: 16px;
                            padding: 0 10px 6px;
                            color: #29a803;
                          "
                        ></i
                        >Create and optimize routes
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <i
                          class="material-icons check text-default"
                          style="
                            font-size: 16px;
                            padding: 0 10px 6px;
                            color: #29a803;
                          "
                        ></i
                        >Capture proof of delivery
                      </td>
                      <td>
                        <i
                          class="material-icons check text-default"
                          style="
                            font-size: 16px;
                            padding: 0 10px 6px;
                            color: #29a803;
                          "
                        ></i
                        >Capture proof of delivery
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <i
                          class="material-icons check text-default"
                          style="
                            font-size: 16px;
                            padding: 0 10px 6px;
                            color: #29a803;
                          "
                        ></i
                        >Unlimited optimised routes
                      </td>
                      <td>
                        <i
                          class="material-icons check text-default"
                          style="
                            font-size: 16px;
                            padding: 0 10px 6px;
                            color: #29a803;
                          "
                        ></i
                        >Unlimited optimised routes
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <i
                          class="material-icons check text-default"
                          style="
                            font-size: 16px;
                            padding: 0 10px 6px;
                            color: #29a803;
                          "
                        ></i
                        >1 driver
                      </td>
                      <td>
                        <i
                          class="material-icons check text-default"
                          style="
                            font-size: 16px;
                            padding: 0 10px 6px;
                            color: #29a803;
                          "
                        ></i
                        >Unlimited drivers and vehicles
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <i
                          class="material-icons check text-default"
                          style="
                            font-size: 16px;
                            padding: 0 10px 6px;
                            color: #29a803;
                          "
                        ></i
                        >Unlimited delivery history
                      </td>
                      <td>
                        <i
                          class="material-icons check text-default"
                          style="
                            font-size: 16px;
                            padding: 0 10px 6px;
                            color: #29a803;
                          "
                        ></i
                        >Unlimited delivery history
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <button
                          class="btn btnl1 btn-sm btn-block btn-ghost"
                          @click="register()"
                          v-on:click.stop
                          type="submit"
                          style="
                            margin-left: 25px;
                            font-size: 14px;
                            width: 300px;
                          "
                        >
                          <i
                            class="material-icons person_outline text-default"
                            style="
                              font-size: 14px;
                              padding-bottom: 5px;
                              color: #ffffff;
                            "
                          ></i>
                          Start free trial
                        </button>
                      </td>
                      <td>
                        <button
                          class="btn btnl1 btn-sm btn-block btn-ghost"
                          @click="register()"
                          v-on:click.stop
                          type="submit"
                          style="
                            margin-left: 25px;
                            font-size: 14px;
                            width: 300px;
                          "
                        >
                          <i
                            class="material-icons person_outline text-default"
                            style="
                              font-size: 14px;
                              padding-bottom: 5px;
                              color: #ffffff;
                            "
                          ></i>
                          Start free trial
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="col-sm-3"></div>
              </div>
            </center>
          </div>
        </div>
      </section>
    </article>

    <Footer />
    <vue-cookies-consent
      backgroundButton="#1972f5"
      borderRadius="5"
      backgroundButtonHover="#3A4F52"
      offsetY="5"
      style="z-index: 1000"
    >
      <template #description>
        <p>
          We use cookies to ensure you get the best experience on our website
          <router-link to="privacy-policy"
            ><span style="color: #0a64eb">Read more</span></router-link
          >
        </p>
      </template>
      <template #button>Accept cookies</template>
    </vue-cookies-consent>
  </v-container>
</template>

<script>
import Header from "./Header.vue";
import Footer from "./Footer.vue";
import VueCookiesConsent from "@norvikit/vue-cookies-consent";
export default {
  components: {
    Header,
    Footer,
    VueCookiesConsent,
  },
  data() {
    return {
      email: "",
      password: "",
      errorMsg: "",
    };
  },
  computed: {},
  methods: {
    register() {
      this.$router.push({
        name: "Signup",
      });
    },
    openGooglePlay() {
      window.open(
        "https://play.google.com/store/apps/details?id=com.mapamai.maps.batchgeocode",
        "_blank"
      );
    },
    openAppstore() {
      window.open(
        "https://apps.apple.com/pl/app/maposcope-fast-route-planner/id1502155614",
        "_blank"
      );
    },
  },
};
</script>


<style scoped>
a {
  color: red;
}
.error-msg {
  color: red;
  font-weight: bold;
}

.wlink a,
a:active,
a:hover {
  color: #2c405a !important;
}
.v-application a {
  color: #2c405a !important;
}

.btnl1 {
  color: #ffffff !important;
  background-color: #1972f5;
}

.btnl1:hover {
  background-color: #0a64eb;
}

.btnl2 {
  color: #ffffff !important;
  background-color: #eceff6;
}

.btnl2:hover {
  background-color: #eceff6;
}
.fullwidthsec {
  max-width: 1200px;
}

ul li::before {
  content: "";
}

ul li {
  content: "";
}
@media only screen and (max-width: 600px) {
  .fullwidthsec {
    max-width: 350px;
  }
}
</style>